import React from "react";
import { useTheme } from "@material-ui/core";
import {
  IconButton,
  Badge,
  Typography,
  Box,
  BoxProps,
  Grid,
  Tooltip,
} from "@mui/material";

import { BellNotification, BellSoft } from "@components/Icons";
import Modal from "@components/Modal";
import Button from "@components/Button";

import { useNotificationPortal } from "@context/notification/hook/useNotificationPortal";

import Notifications from "./Notifications";
import useNotification from "./hook/useNotification";
import { useRoadLoadNotificationBell } from "./hook/useRoadLoadNotificationBell";

import { useFlags } from "flagsmith/react";
import { NOTIFICATION_FLAG } from "@utils/featureFlags";

const Notification: React.FC<BoxProps> = () => {
  const flag = useFlags([NOTIFICATION_FLAG]);
  const isEnableFlag = flag.admin_sidebar_notification.enabled;
  const theme = useTheme();

  // Lógica já existente (roadLoad)
  const {
    state: {
      anchorEl,
      notificationHistory,
      selectedMessage,
      messageCount,
      hasNotification: hasRoadLoadNotification,
    },
    actions: {
      handleOpenMenu,
      handleCloseMenu,
      handleOpenModal,
      handleCloseModal,
    },
  } = useRoadLoadNotificationBell();

  // Lógica do Portal de Notificações (comercial)
  const {
    state: {
      notifications: portalNotifications,
      messageReadCount: messageCountPortal,
      hasPortalNotification,
    },
    action: { reopen },
  } = useNotificationPortal();

  const {
    action: { unifieldNotification },
  } = useNotification();

  const notifications = unifieldNotification(
    notificationHistory,
    isEnableFlag ? portalNotifications : []
  );

  const hasNotification =
    hasRoadLoadNotification || (isEnableFlag && hasPortalNotification);

  const countNotification =
    (messageCount ?? 0) + (isEnableFlag ? messageCountPortal : 0);

  const handleClickBell = (event: React.MouseEvent<HTMLElement>) => {
    // abre o menu de notificações operacionais
    handleOpenMenu(event);
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Tooltip
          title={
            !hasNotification ? (
              <Typography sx={{ fontSize: 10 }}>
                Você não possui notificações
              </Typography>
            ) : (
              ""
            )
          }
          placement="bottom"
        >
          <span>
            <IconButton
              id="positioned-button"
              aria-controls={Boolean(anchorEl) ? "positioned-menu" : undefined}
              aria-expanded={Boolean(anchorEl) ? "true" : undefined}
              aria-haspopup="true"
              color="info"
              onClick={handleClickBell}
              sx={{
                backgroundColor: "#fff",
                borderRadius: 1,
                opacity: !hasNotification ? "0.4" : "1",
              }}
            >
              <Badge
                badgeContent={countNotification}
                sx={{
                  "& .MuiBadge-badge": {
                    right: 0,
                    top: 0,
                    color: "#fff",
                    border: `2px solid ${theme.palette.background.paper}`,
                    padding: "0 4px",
                    background: theme.palette.primary.main,
                  },
                }}
              >
                <BellNotification sx={{ fontSize: "21px" }} />
              </Badge>
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      {hasNotification && (
        <Notifications
          anchorEl={anchorEl}
          handleCloseMenu={handleCloseMenu}
          handleOpenModal={handleOpenModal}
          handleOpenPortalModal={reopen}
          notifications={notifications ?? []}
        />
      )}

      {/* MODAL das notificações existentes */}
      <Modal
        open={Boolean(selectedMessage)}
        onClose={handleCloseModal}
        hiddenButton
      >
        <Box
          sx={{
            px: 1,
            pb: 2,
            backgroundColor: "white",
            margin: "auto",
            width: { xs: "295px", md: "400px" },
            maxHeight: "400px",
            minWidth: "fit-content",
          }}
        >
          {selectedMessage && (
            <Grid
              container
              textAlign="center"
              justifyContent="center"
              gap={2.5}
            >
              <Grid item xs={12}>
                <BellSoft className="bellSoft" sx={{ fontSize: "80px" }} />
              </Grid>

              <Grid item xs={12}>
                <Typography
                  id="message-title"
                  variant="h4"
                  component="h2"
                  sx={{ fontWeight: 700 }}
                >
                  {selectedMessage.title}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  id="message-description"
                  variant="body1"
                  component="p"
                  sx={{ fontWeight: 500 }}
                >
                  {selectedMessage.message}
                </Typography>
              </Grid>

              <Grid item xs={10} sm={10} md={9} lg={7}>
                {!selectedMessage.read && (
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleCloseModal}
                    sx={{ fontSize: "11.5px" }}
                  >
                    Marcar como lida
                  </Button>
                )}
              </Grid>
            </Grid>
          )}
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default Notification;
